<template>
    <div>
        <div v-if="isLoading" class="div-loading color-pink">
            <h2>Loading</h2>
            <div><span class="icon"><img :src="`/Assets/img/spin.svg`" /></span></div>
        </div>
        <div id="articles-wrapper" v-if="articles && articles.length > 0">
            <ArticleBox v-for="(article, index) in articles"
                        :item="article"
                        :index="index"
                        :key="article.articleId"
                        :article="article" />
        </div>
        <div class="load-more-container" v-if="showMoreButton">
            <button v-if="isLoadingMore">
                <span class="icon"><img :src="`/Assets/img/spin.svg`" /></span>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import ArticleBox from '@/components/ArticleBox.vue'
import api from '@/api'
import ga from '@/helpers/ga'
import clicky from '@/helpers/clicky'
import settings from '@/settings'
import util from '@/helpers/util'
import { Article } from '@/classes/Articles'

const props = defineProps<{
    excludeArticles?: number
}>()

const route = useRoute()
const isLoading = ref(false)
const isLoadingMore = ref(false)
const isGiftList = ref(false)
const articles = ref<Article[]>([])
const perPage = ref(10)
const pageNumber = ref(1)
const showMoreButton = ref(false)
const autoLoadMoreEnabled = ref(false)

const finalExcludeArticle = computed(() => {
    return props.excludeArticles ?? 0
})

const init = async () => {
    isLoading.value = true
    isLoadingMore.value = false
    isGiftList.value = false
    articles.value = []

    if (route.name === 'giftideas' || route.name === 'giftlist' || route.name === 'giftlist2') {
        isGiftList.value = true
    }

    await loadData()
    isLoading.value = false
}

const autoLoadMore = () => {
    if (autoLoadMoreEnabled.value) {
        const loadMoreElem = document.querySelector('.load-more-container') as HTMLElement
        if (loadMoreElem && util.checkVisible(loadMoreElem)) {
            loadMoreData()
        }
    }
}

const loadMoreData = async () => {
    ga.event('click', { 'event_category': 'articlepages', 'event_label': pageNumber.value })
    clicky.log('Articles - Load More Data Page #' + pageNumber.value, 'click')
    autoLoadMoreEnabled.value = false
    isLoadingMore.value = true
    await loadData()
    isLoadingMore.value = false
}

const loadData = async () => {
    const response = await api.getArticles(perPage.value, pageNumber.value, finalExcludeArticle.value, isGiftList.value)
    
    if (response.data) {
        showMoreButton.value = response.data.length >= perPage.value

        const tmp = response.data
        tmp.forEach(a => {
            a.imgUrl = 'https://' + settings.siteUrl + a.imgUrl
        })

        articles.value.push(...tmp)
        pageNumber.value++

        setTimeout(() => { autoLoadMoreEnabled.value = true }, 500)
    }
}

onMounted(() => {
    window.addEventListener('scroll', autoLoadMore)
    init()
})

onUnmounted(() => {
    window.removeEventListener('scroll', autoLoadMore)
})
</script>
